import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIS } from 'src/app/apis';
import { MoovInstanceData, IssueData, IssueFullData, MoovData, SubjectData } from './challenges-data';

@Injectable({
  providedIn: 'root'
})

export abstract class AbstractChallengesService {

  abstract getallIssues(counterpartId:string): Observable<IssueData[]>;

  abstract getIssue (issueId:string): Observable<IssueData>;

  abstract getallSubjects(): Observable<IssueData[]>;

  abstract getIssuePerUser(userId: string, issueId: string): Observable<IssueFullData>;

  abstract getMoovsPerIssueAndCounterpart(counterpartId: string, issueId: string, motivationId?:string): Observable<MoovData[]>;

  abstract getmoovsForSelf (issueId: string, motivationId? : string): Observable<MoovData[]>;

  abstract getPastMoovsForUserCounterpart(counterpartId: string): Observable<MoovInstanceData[]>;

  abstract getActiveMoovsForUser (): Observable<MoovInstanceData[]>;

  abstract getPastMoovsforMoovAndCounterpart (counterpartId: string, moovId: string): Observable<MoovInstanceData[]>;
  
  abstract getMoovDetailsForCounterpart (moovId: string, counterpartId: string): Observable<MoovData>;

  abstract activateMoov(moovId: string, counterpartId: string, isMoovForSelf?: boolean): Observable<MoovInstanceData>;

  abstract endMoov(moovId: string, feedbackScore: number, feedbackText: string): Observable<string>;
  
  abstract getTopRecommendedMoovs(counterpartId: string): Observable<MoovData[]>;

  abstract extendActiveMoov(activeMoovId: string): Observable<MoovInstanceData>;

  abstract getActiveMoovsForUserCounterpart(counterpartId: string): Observable<MoovInstanceData[]>;

  abstract addUserEventToMoov (moovId:string, userText: string): Observable<MoovInstanceData>;

  abstract addUserCommentToStep (activeMoovId:string, stepId:string, userText: string): Observable<MoovInstanceData>;

  abstract setStepAsDone (activeMoovId:string, stepId: string): Observable<MoovInstanceData>;

  abstract setStepAsPending (activeMoovId:string, stepId: string): Observable<MoovInstanceData>;
}
